import { CssBaseline, Stack, ThemeProvider } from "@mui/material";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import { Text, Title } from "@src/appV2/redesign/system/ui-components";
import { getTheme } from "@src/appV2/redesign/system/ui-theme";
import { useHistory } from "react-router-dom";

import { RootPaths } from "../App/paths";
import { useLegacyStateContext } from "../LegacyStateBridge/context";
import { ClipboardLogo } from "../lib";
import { PageFooterWrapper } from "../redesign/components/PageFooterWrapper";
import { PageWrapper } from "../redesign/components/PageWrapper";

export function ReactivateSuccessPage() {
  const history = useHistory();
  const {
    session: { authStateHasLoaded },
  } = useLegacyStateContext();

  return (
    <ThemeProvider theme={getTheme()}>
      <CssBaseline />
      <PageWrapper variant="tertiary">
        <Stack
          justifyContent="center"
          alignItems="center"
          sx={{ flex: 1, paddingBottom: 20 }}
          gap={4}
        >
          <ClipboardLogo width={100} />
          <Title component="h4">Your account has been reactivated!</Title>
          <Text>You can now log in to your account.</Text>
        </Stack>

        <PageFooterWrapper>
          <LoadingButton
            fullWidth
            variant="contained"
            isLoading={!authStateHasLoaded}
            onClick={() => {
              history.push(RootPaths.HOME);
            }}
          >
            Continue
          </LoadingButton>
        </PageFooterWrapper>
      </PageWrapper>
    </ThemeProvider>
  );
}
